import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Chip, makeStyles, Tooltip } from '@material-ui/core';
import AddIcon from '@mui/icons-material/Add';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  filterInputs: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  input: {
    width: '160px'
  },
  filtersContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  },
  chip: {
    margin: 0
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  }
}));

const CustomFilters = ({ onFilterChange, customFilters = {} }) => {
  const classes = useStyles();
  const [paramName, setParamName] = useState('');
  const [paramValue, setParamValue] = useState('');

  const handleAddFilter = () => {
    if (paramName.trim() === '' || paramValue.trim() === '') return;

    // Update filters in parent component
    const newFilters = {
      ...customFilters,
      [paramName]: paramValue
    };

    onFilterChange('customFilters', newFilters);

    // Reset inputs
    setParamName('');
    setParamValue('');
  };

  const handleDeleteFilter = (filterName) => {
    const newFilters = { ...customFilters };
    delete newFilters[filterName];

    onFilterChange('customFilters', newFilters);
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.titleContainer}>
        <Typography variant='subtitle2'>Custom Filters</Typography>
        <Tooltip title="These filters apply only to orders, not analytics. You can use dot notation for nested fields (e.g. 'processedResponseData.order_id')">
          <HelpOutlineIcon className={classes.helpIcon} fontSize='small' sx={{ ml: 0.5 }} />
        </Tooltip>
      </Box>

      <Box className={classes.filterInputs}>
        <TextField
          label='Parameter Name'
          variant='outlined'
          size='small'
          className={classes.input}
          value={paramName}
          onChange={(e) => setParamName(e.target.value)}
          placeholder='e.g. email'
        />
        <TextField
          label='Parameter Value'
          variant='outlined'
          size='small'
          className={classes.input}
          value={paramValue}
          onChange={(e) => setParamValue(e.target.value)}
        />
        <Button
          variant='contained'
          color='primary'
          size='small'
          startIcon={<AddIcon />}
          onClick={handleAddFilter}
          disabled={!paramName || !paramValue}
        >
          Add
        </Button>
      </Box>

      {Object.keys(customFilters).length > 0 && (
        <Box className={classes.filtersContainer}>
          {Object.entries(customFilters).map(([name, value], index) => (
            <Chip
              key={index}
              label={`${name}: ${value}`}
              onDelete={() => handleDeleteFilter(name)}
              className={classes.chip}
              color='primary'
              variant='outlined'
              size='small'
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default CustomFilters;
